module.exports = __webpack_public_path__ + "img/logo_light.db5bcef6.svg";